module.exports = __webpack_public_path__ + "img/index_banner_default.759baa74.png";